import { camelizeKeys } from "humps";
import omitBy from "lodash/omitBy";
import isUndefined from "lodash/isUndefined";
import { PAGES_TYPES, SECTIONS, SECTIONS_TYPES } from "../constants";

export const getAnalyticsParams = (params = {}) => {
  const camelizedParams = camelizeKeys(params);
  const {
    sourceElement,
    sourceName,
    sourcePage,
    sourcePageType,
  } = camelizedParams;
  if (!sourceElement && !sourceName && !sourcePage && !sourcePageType) {
    return {
      sourceElement: SECTIONS_TYPES.DIRECT,
      sourceName: SECTIONS.DIRECT,
      sourcePage: PAGES_TYPES.DIRECT,
      sourcePageType: PAGES_TYPES.DIRECT,
    };
  }
  return omitBy(
    {
      sourceElement,
      sourceName,
      sourcePage,
      sourcePageType,
    },
    isUndefined,
  );
};
